import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { homePartners } from '@/mocks/partners';

export default function Partners() {
  const d = homePartners;

  return (
    <section id="partners" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading title={d.title} en={d.en} subtitle={d.subtitle} />
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {d.groups.map((g, idx) => (
            <Reveal key={g.name} delay={idx * 80}>
              <div className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors duration-300 hover:border-primary-300">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-100 text-primary-600">
                  <i className={`${g.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug">
                  {g.name}
                </h3>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed flex-1">{g.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}